'use strict';

// external imports

// prime react imports

// shared imports
import {Condition} from '~/shared/src/utilities/condition';
import {Query} from '~/shared/src/utilities/query';
import {dataExtraction} from '~/shared/src/utilities/dataExtraction';

// frontend imports


export const graphUtilities = {
    getQuery: ( dataContext : string, graphId : number ) : Query | undefined => {
        const graphItem = global.data[ dataContext ]?.items?.[ graphId ];

        return graphItem ? dataExtraction.extractQuery( graphItem, dataContext ) : undefined;
    },

    getCondition: ( dataContext : string, graphId : number ) : Condition | undefined => {
        const graphItem = global.data[ dataContext ]?.items?.[ graphId ],
              query     = graphUtilities.getQuery( dataContext, graphId );

        return graphItem ? dataExtraction.extractCondition( graphItem, dataContext, query?.dataStructure, undefined, true ) : undefined;
    }
}
